import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule,ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { EstimateDetailsService } from './estimate-details-service';
import { jsPDF } from 'jspdf';
import { Canvg } from "canvg";
import html2canvas from "html2canvas";
import { Loading } from '../loading/loading';
import { GlobalVariable } from '../globals';



@Component({
  selector: 'estimate-details/:id/:name',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, HttpClientModule, Loading,ReactiveFormsModule],
  templateUrl: './estimate-details.html',
  styleUrls: ['./estimate-details.scss']
})
export class EstimateDetails implements OnInit {
  showPendingInfo: boolean = false; 
  serviceId: any;
  callbackForm: FormGroup;
  serviceName: any;
  taxes: number = 0;
  serviceDetail: any = {
    serviceKitDefinition: {
      image: null,
      notes: null,
      heading: null,
      description: null
    },
    parts: [],
    labours: [],
    whatsIncluded: [],
    faqs: []
  };
  loading = false;
  grandTotal: any;
  labourGstRate: any;
  successMessage: string = '';
  userId = GlobalVariable.userId;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private service: EstimateDetailsService) {this.callbackForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      issue: ['']
    });}

    ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.serviceId = params.get('id');
      this.serviceName = params.get('name');
    });
    // Only call API if both values exist
    if (this.serviceId && this.serviceName) {
      this.fetchServiceDetail();
    } else {
      console.error('Route params missing: serviceId or serviceName');
    }
  
}



fetchServiceDetail() {
  this.loading = true;
  if (!this.serviceId || !this.serviceName) return;
  this.service.getServiceDetail(this.serviceId, this.serviceName).subscribe({
    next: (response: any) => {
      this.loading = false;
      console.log('API Response:', response);
      const data = response?.data || {};
      this.serviceDetail.serviceKitDefinition = {
        image: data.serviceKitDefinition?.image ?? null,
        notes: data.serviceKitDefinition?.notes ?? null,
        heading: data.serviceKitDefinition?.heading ?? null,
        description: data.serviceKitDefinition?.description ?? null
      };
      this.serviceDetail.parts = data.parts ?? [];
      this.serviceDetail.labours = data.labours ?? [];
      this.serviceDetail.whatsIncluded = data.whatsIncluded ?? [];
      this.serviceDetail.faqs = data.faqs ?? [];
      this.loading = false;
      this.serviceDetail.grandTotal = data.grandTotal ?? 0;
       this.grandTotal = this.serviceDetail.grandTotal;
       if (data.labours && data.labours.length > 0) {
        this.labourGstRate = data.labours[0].gstRate;
      } else {
        this.labourGstRate = null;
      }
    },
    
    error: (error: any) => {
      console.error('Error fetching service details:', error);
      this.loading = false;
    }
  });
}

downloadPDF() {
  // Find the element you want to capture
  const element = document.querySelector('.estimate-details-main-page') as HTMLElement;
  
  // Check if the element exists
  if (!element) {
    console.error('Element not found!');
    return;
  }

  // Capture the element and convert it into a canvas
  html2canvas(element, { scale: 2 }).then(canvas => {
    // Get image data from the canvas
    const imgData = canvas.toDataURL('image/png');

    // Create a new PDF document
    const pdf = new jsPDF('p', 'mm', 'a4'); // 'p' for portrait orientation

    // Get the image properties to maintain aspect ratio
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = 210; // A4 width in millimeters
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    // Add the image to the PDF document
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

    // Save/download the PDF with the given filename
    pdf.save('estimate-details.pdf');
  }).catch(err => {
    console.error('Failed to generate PDF:', err);
  });
}
downloadPDFRedirectToDownloadPage(){
    this.router.navigate(['/estimate-details-download']);
}
get hasPendingParts(): boolean {
  return this.pendingPartNames.length > 0;
  if (!this.serviceDetail.parts || this.serviceDetail.parts.length === 0) return false;
  return this.serviceDetail.parts.some(
    (part: any) => !part.brandName || part.zohoPartPrice === null
  );
}

get partsSubtotal(): number {
  if (!this.serviceDetail.parts || this.serviceDetail.parts.length === 0) return 0;
  return this.serviceDetail.parts.reduce((sum: number, part: any) => {
    return sum + (part.zohoPartPrice ? part.zohoPartPrice : 0);
  }, 0);
}

get pendingPartNames(): string[] {
    if (!this.serviceDetail?.parts || this.serviceDetail.parts.length === 0) return [];
    return this.serviceDetail.parts
      .filter((part: any) => !part.zohoPartPrice) // price missing
      .map((part: any) => part.partName || 'Unnamed Part');
  }


get labourSubtotal(): number | null {
  if (!this.serviceDetail.labours || this.serviceDetail.labours.length === 0) return null;
  const total = this.serviceDetail.labours.reduce((sum: number, labour: any) => {
    return sum + (labour.labourRate ? labour.labourRate : 0);
  }, 0);
  return total > 0 ? total : null;
}

get taxAmount(): number | null {
  if (this.hasPendingParts) return null; // Taxes cannot be shown
  if (this.labourSubtotal || this.partsSubtotal) {
    const base = (this.partsSubtotal ?? 0) + (this.labourSubtotal ?? 0);
    return base > 0 ? Math.round(base * 0.18) : null; // 18% GST
  }
  return null;
}

get estimatedTotal(): number | null {
  if (this.hasPendingParts) return null; // Estimated total pending
  return (this.partsSubtotal ?? 0) + (this.labourSubtotal ?? 0) + (this.taxAmount ?? 0);
}

//  submitForm() {
//     if (this.callbackForm.invalid) return;

//     const { name, mobile, issue } = this.callbackForm.value;

//     const payload = {
//       garageKey: this.key,
//       userId: this.userId,
//       name,
//       phoneNumber: mobile,
//       issue,
//     };

//     this.service.createBooking(payload).subscribe({
//       next: (res) => {
//         if (res.code === 200) {
//           this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

//           // ✅ hide the request callback modal first
//           const requestModalEl = document.getElementById('requestCallBackModal');
//           const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
//           requestModal?.hide();

//           // ✅ wait a tick before showing success modal
//           setTimeout(() => {
//             const successModalEl = document.getElementById('successModal');
//             if (successModalEl) {
//               const successModal = new (window as any).bootstrap.Modal(successModalEl);
//               successModal.show();
//             }
//           }, 200);

//           // reset form
//           this.callbackForm.reset();
//           // this.selectedCoupon = null;
//         } else {
//           alert('Something went wrong. Please try again.');
//         }
//       },
//       error: (err: any) => {
//         console.error('Error creating booking:', err);
//         alert('Error creating booking. Please try again.');
//       }
//     });
//   }

submitForm() {
  if (this.callbackForm.invalid) return;

  // Get garageKey from localStorage
  const garageKey = localStorage.getItem('garageKey');
  if (!garageKey) {
    alert("Garage not selected!");
    return;
  }

  const { name, mobile, issue } = this.callbackForm.value;

  const payload = {
    garageKey: garageKey,
    serviceId: this.serviceId,   // ⭐ ADD THIS LINE
    userId: this.userId,
    name,
    phoneNumber: mobile,
    issue,
  };

  this.service.createBooking(payload).subscribe({
    next: (res) => {
      if (res.code === 200) {
        this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

        // Close request modal
        const requestModalEl = document.getElementById('requestCallBackModal');
        const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
        requestModal?.hide();

        // Show success popup
        setTimeout(() => {
          const successModalEl = document.getElementById('successModal');
          if (successModalEl) {
            const successModal = new (window as any).bootstrap.Modal(successModalEl);
            successModal.show();
          }
        }, 200);

        // Reset form
        this.callbackForm.reset();

        // Redirect to download page
        // setTimeout(() => {
        //   this.router.navigate(['/estimate-details-download']);
        // }, 700);
        setTimeout(() => {
  this.router.navigate(
    ['/estimate-details-download'],
    {
      state: {
        customerName: name,
        customerPhoneNumber: mobile
      }
    }
  );
}, 700);

      } 
      else {
        alert('Something went wrong. Please try again.');
      }
    },
    error: () => {
      alert('Error creating booking. Please try again.');
    }
  });
}

}
